import React, { useEffect, useState } from "react";
import { buildApiUrl, API_ENDPOINTS } from "../../config/api";
import { apiRequest } from "../../utils/apiUtils";
import { stopImpersonation } from "../../utils/impersonation";
import "./ImpersonationBanner.css";

export default function ImpersonationBanner() {
  const [impersonation, setImpersonation] = useState(null);
  const [loading, setLoading]             = useState(false);
  const [error, setError]                 = useState("");
  const [navbarHeight, setNavbarHeight]   = useState(60);

  useEffect(() => {
    const navbarEl = document.querySelector("header");
    if (!navbarEl) return;

    const update = () =>
      setNavbarHeight(navbarEl.getBoundingClientRect().height);
    update();

    const observer = new ResizeObserver(update);
    observer.observe(navbarEl);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let cancelled = false;
    apiRequest(buildApiUrl(API_ENDPOINTS.current))
      .then((data) => {
        if (!cancelled && data?.impersonation?.active) {
          setImpersonation({
            firstName:  data.datosUsuario?.first_name  || "",
            lastName:   data.datosUsuario?.last_name   || "",
            email:      data.datosUsuario?.email       || "",
            adminEmail: data.impersonation.adminEmail  || "",
          });
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!impersonation) return null;

  const handleStop = async () => {
    setLoading(true);
    setError("");
    try {
      await stopImpersonation();
    } catch (err) {
      setError(err.message || "No se pudo restaurar la sesión. Intenta de nuevo.");
      setLoading(false);
    }
  };

  return (
    <div
      role="status"
      className="impersonation-banner"
      style={{ top: navbarHeight }}
    >
      <span className="impersonation-banner__text">
        Estás viendo la aplicación como{" "}
        <strong>
          {impersonation.firstName} {impersonation.lastName}
        </strong>{" "}
        ({impersonation.email}). Sesión de administrador:{" "}
        {impersonation.adminEmail}.
      </span>
      <div className="impersonation-banner__actions">
        {error && (
          <span className="impersonation-banner__error">{error}</span>
        )}
        <button
          className="impersonation-banner__btn"
          onClick={handleStop}
          disabled={loading}
        >
          {loading ? "Saliendo…" : "Volver a mi sesión"}
        </button>
      </div>
    </div>
  );
}
